import { PHASE_OF_PLAY_META } from '@4cm/core/phaseOfPlay';
import type { PhaseOfPlay } from '@4cm/core/phaseOfPlay';
import { CornerTag } from './primitives';
import type { WeekDay } from '../lib/queries/useWeekStrip';

interface WeekStripProps {
  days: WeekDay[];
  activePhase: PhaseOfPlay;
}

/**
 * Seven-column week grid rendered from `useWeekStrip` output. Each day
 * shows either a phase-of-play chip (when sessions exist + cover a
 * dominant phase), a 4-corner tag (legacy fallback), or a plain "rest"
 * label. Today is highlighted; days not on the active phase dim out.
 *
 * SeverityBanner is rendered alongside the strip by callers — it
 * needs the active phase's coverage % which lives in Home's state.
 */
export function WeekStrip({ days, activePhase }: WeekStripProps) {
  return (
    <div className="week-strip">
      {days.map((day, i) => (
        <div
          key={i}
          className="week-day"
          data-today={day.today || undefined}
          data-muted={day.phase && day.phase !== activePhase ? true : undefined}
        >
          <div className="week-day__d">{day.d}</div>
          {day.phase ? (
            <span
              className="phase-tag"
              data-phase={day.phase}
              data-active={day.phase === activePhase || undefined}
            >
              <span aria-hidden="true">{PHASE_OF_PLAY_META[day.phase].glyph}</span>
              {PHASE_OF_PLAY_META[day.phase].label}
            </span>
          ) : day.corner ? (
            <CornerTag corner={day.corner} label={day.label} filled={day.today} />
          ) : (
            <span className="week-day__label">{day.label}</span>
          )}
        </div>
      ))}
    </div>
  );
}
